import { Box, Flex, ScrollArea, Skeleton } from '@mantine/core';
import type { FC } from 'react';
import { useTagService } from '../../services';
import CuisineBadge from './CuisineBadge';
import { Tag } from '../../services/tag/tag.schema';

type Props = {
  data: Tag[] | undefined;
  isLoading: boolean;
  isSuccess: boolean;
};

const CuisineBadgesContainer: FC = () => {
  const { data, isLoading, isSuccess } = useTagService();

  return (
    <>
      <Box mt={16} px={8}>
        <ScrollArea w={'100%'} type='never' scrollbarSize={2}>
          <Flex
            style={{ userSelect: 'none' }}
            // gap={4}
          >
            {isLoading
              ? Array(6)
                  .fill(0)
                  .map((_, index) => <Skeleton key={index} visible={true} w={90} height={24} mr={4} />)
              : null}

            {isSuccess && Array.isArray(data) ? (
              <>
                <CuisineBadge tag={{ tag_id: 0, name: 'All', created_at: '0', updated_at: '0' }} />
                {data.map((tag, index) => (
                  <CuisineBadge tag={tag} key={index} />
                ))}
              </>
            ) : null}
          </Flex>
        </ScrollArea>
      </Box>
    </>
  );
};

export default CuisineBadgesContainer;
